export enum View {
  actions = "actions",
  journeys = "journeys",
  missions = "missions",
  impact = "impact",
}

export enum BodySliceType {
  BodyTextSlice = "BodyTextSlice",
  BodyImageSlice = "BodyImageSlice",
  BodyQuoteSlice = "BodyQuoteSlice",
  BodyEmbedSlice = "BodyEmbedSlice",
}

export enum FootprintSector {
  home = "home",
  shopping = "shopping",
  transport = "transport",
  food = "food",
}

// missions
export enum MissionType {
  ACT = "ACT",
  LEARN = "LEARN",
  MEASURE = "MEASURE",
}

export enum MissionSubType {
  ALL = "ALL",
  ENERGY = "ENERGY",
  FOOD = "FOOD",
  MOBILITY = "MOBILITY",
  PURCHASE = "PURCHASE",
  SOCIAL = "SOCIAL",
  TRAVEL = "TRAVEL",
  WASTE = "WASTE",
  ENVIRONMENT = "ENVIRONMENT",
  WATER = "WATER",
  JOURNEY = "JOURNEY",
  DAILYEPISODE = "DAILYEPISODE",
  TYPEFORM_BASE = "TYPEFORM_BASE",
  TYPEFORM_REFINE = "TYPEFORM_REFINE",
  FIXED = "FIXED",
  DAILYQUIZ = "DAILYQUIZ",
}

export enum MissionPeriod {
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
  CUSTOM = "CUSTOM",
}
